var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"col-span-full grid min-h-40 grid-cols-1"},[_c('z-chart',{ref:"base-graph-chart",staticClass:"flex-grow md:mx-auto",attrs:{"data-sets":_vm.datasets,"height":_vm.chartHeight,"labels":_vm.labels,"colors":_vm.colors,"type":_vm.chartType,"tooltip-options":{
      formatTooltipY: _vm.formatIntl
    },"axis-options":_vm.axisOptions,"line-options":_vm.lineOptions,"bar-options":_vm.barOptions,"y-axis-min":0}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }